/* eslint-disable no-unused-vars */
import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { BreakPoint, Color } from '../../../../asset/styles';

const StyledBody = styled.div`
  border-top: solid 1px ${Color.border.ultraLightGray};
  box-sizing: border-box;
  position: relative;
  left: 0;
  width: 100%;
  z-index: 1000;

  @media (min-width: ${BreakPoint.desktop}) {
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
    top: 0;
    /*height: 246px;*/
    max-height: ${props => 318 + 32 - props.headerHeight}px;
    width: 456px;
  }
`;

const StyledBodyDiv = styled.div`
  @media (min-width: ${BreakPoint.desktop}) {
    /* footer height 空ける */
    padding-bottom: ${props => props.padding}px;
    word-break: break-all;
  }
`;

/**
 * {@link Inquiry} の下部 component - 下記 component の wrapper
 * - phase 1 - scroll 位置を制御するのに `ref` していたので `forwardRef` した
 * - scroll 制御を使用しないようにしたので `ref` いらないのかも???
 * - {@link BodyCheckboxes}
 * - {@link FreeComment}
 * - {@link Footer}
 * @type {React.ComponentType<{} & React.ClassAttributes<any>>}
 * @return {*} React.node
 */
const Body = forwardRef((props, ref) => {
  const { padding } = props;
  return (
    <StyledBody
      className={`${props.className} Body`}
      headerHeight={props.headerHeight}
    >
      <StyledBodyDiv
        className={'Inquiry-StyledBody-div'}
        ref={ref}
        padding={padding}
      >
        {props.children}
      </StyledBodyDiv>
    </StyledBody>
  );
});

export default Body;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/body/Body.js